const GET_POPUPS = 'popup/GET_MEIDAS'
const GET_POPUP = 'popup/GET_POPUP'
const DELETE_POPUP = 'popup/DELETE'
//수정과 생성은 같은 메소드로 이용
const POST_POPUP = 'popup/POST'

export const getPopups = popups => ({
  type: GET_POPUPS,
  popups
})

export const getPopup = popup => ({
  type:GET_POPUP,
  popup
})

export const deletePopup = () => ({
  type:DELETE_POPUP,
})

export const postPopup = () => ({
  type: POST_POPUP
})

const initialPopup = [
  {
    id: 1,
    title: "(주)유스비 비대면 바우처 공급기업 선정",
    press: "중앙일보",
    date: '2020-10-10'
  },
  {
    id: 2,
    title: "(주)유스비 비대면 바우처 공급기업 선정",
    press: "중앙일보",
    date: '2020-10-10'
  },
  {
    id: 3,
    title: "(주)유스비 비대면 바우처 공급기업 선정",
    press: "중앙일보",
    date: '2020-10-10'
  },
  {
    id: 4,
    title: "(주)유스비 비대면 바우처 공급기업 선정",
    press: "중앙일보",
    date: '2020-10-10'
  },
  {
    id: 5,
    title: "(주)유스비 비대면 바우처 공급기업 선정",
    press: "중앙일보",
    date: '2020-10-10'
  },
]

export default function popupReducer(state= initialPopup, action){
  switch(action.type){
    case GET_POPUPS:
      return state
    case GET_POPUP:
      return state;
    case DELETE_POPUP:
      return state;
    case POST_POPUP:
      return state;
    default :
      return state;
  }
}